import Message from './src/main.js';
export default Message;



// WEBPACK FOOTER //
// ./packages/message/index.js